module.exports = __webpack_public_path__ + "static/media/winSFX.a9286976.mp3";